import React, { useState } from 'react';
import "./JuryTitleBar.scss";
import { GreyDescription } from '../GlobalText';
import { MdMessage, MdClose } from 'react-icons/md';
import { IMAGES_URL } from '../../../Url/Url';

export const JuryTitleBar = ({ logoImg, eventName, fName, lName, messageHtml }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className='jury_title_bar'>
        <img src={`${IMAGES_URL}/${logoImg}`} alt="logo" className='event_logo' />
        <GreyDescription>{eventName}</GreyDescription>

        <button type='button' className='message_button' onClick={() => setIsModalOpen(true)}>
          <MdMessage size={20} />
        </button>

        <div className="usertitlebar_div"></div>
      </div>

      {isModalOpen && (
        <div className="fullpage_modal_overlay">
          <div className="fullpage_modal_content">
            <button className="close_btn" onClick={() => setIsModalOpen(false)}>
              <MdClose size={24} />
            </button>

            <div
              className="modal_body"
              dangerouslySetInnerHTML={{ __html: messageHtml }}
            />
          </div>
        </div>
      )}
    </>
  );
};
